import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
//import Main from "./pages/main";
import Login from "./pages/login";
import MainMenu from "./pages/mainmenu";
import Translation from "./translation/translation";
import Context from "./context/context";
import AdminMenu from "./pages/adminmenu";
import SettingsMenu from "./pages/settingsmenu";
import ReportsMenu from "./pages/reportsmenu";
import ContragentsMenu from "./pages/contragentsmenu";
import ChangePassword from "./pages/changepassword";
import Groups from "./pages/groups";
import Users from "./pages/users";
import Error from "./pages/error";
import WarehouseQuery from "./pages/warehousequery";
import ArticleGrouping from "./pages/articlegrouping";
//import Comm from "./comm/comm";
import Articles from "./pages/articles";
import Logout from "./pages/logout";
import InOut from "./pages/inout";
import ArticleSorters from "./pages/articlesorters";
import Operators from "./pages/operators";
import OperatorSorters from "./pages/operatorsorters";
import CompanyData from "./pages/companydata";
import Sorters from "./pages/sorters";
import Accounts from "./pages/accounts";
import Barcodes from "./pages/barcodes";
import EditQuantity from "./pages/editquantity";
import Contragents from "./pages/contragents";
import ManualResort from "./pages/manualresort";
import Sales from "./pages/sales";
import SalesReport from "./pages/salesreport";
import DeliveriesReport from "./pages/deliveriesreport";
import Deliveries from "./pages/deliveries";
import OnTheWay from "./pages/ontheway";
import Invoices from "./pages/invoices";
import Corrections from "./pages/corrections";
import moment from "moment";
// import $ from "jquery";
import SalesReportResult from "./pages/salesreportresult";
import DisplayPackingList from "./pages/displaypackinglist";
import ErrorSort from "./pages/errorsort";
import EditDeliveries from "./pages/editdeliveries";
import EditSales from "./pages/editsales";
import ShopsMenu from "./pages/shopsmenu";
import ShopAdministration from "./pages/shopadministration";
import N18odit from "./pages/n18odit";
import InvoicesImport from "./pages/invoicesimport";
import ShopReportDetails from "./pages/shopreportdetails";
import ShopReportShort from "./pages/shopreportshort";
import ShopReportPrice from "./pages/shopreportprice";
import Payments from "./pages/payments";
import N18Tables from "./pages/n18tables";
import User2Sorter from "./pages/user2sorter";
import BarcodeReport from "./pages/barcodereport";
import Tare1 from "./pages/tare1";
import Tare2 from "./pages/tare2";
import PosterminalReport from "./pages/posterminalreport";
import RecapForPeriodReport from "./pages/recapperiodreport";

class App extends Component {
    constructor(props) {
        super(props);
        // console.log(this.props._config); // available here if needed
        moment.updateLocale(moment.locale(), {
            week: {
                dow: 1,
            },
        });

        this.state = {
            Languages: Translation.GetLanguages(),
            SelectedLanguage: Translation.GetLanguage(),
            Logged: Context.IsLogged(),
        };
    }

    SetLanguage(langId) {
        Translation.SetLanguage(langId);
        this.setState({ SelectedLanguage: langId });
    }

    render() {
        var defaultComponent = AdminMenu;
        // if (Context.HasRight("rtax") && Context.ctx.username !== "admin") defaultComponent = N18odit;

        return (
            <div className="wrapper">
                <MainMenu Logged={this.state.Logged} />

                <div className="main-panel">
                    <nav className="navbar navbar-default navbar-fixed">
                        <div className="container-fluid">
                            <div className="navbar-header">
                                <button
                                    type="button"
                                    className="navbar-toggle"
                                    data-toggle="collapse"
                                    data-target="#navigation-example-2"
                                >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                </button>
                            </div>
                            <div className="collapse navbar-collapse">
                                <ul className="nav navbar-nav navbar-right">
                                    <li>
                                        <select
                                            id="ddlLanguage"
                                            className="form-control"
                                            defaultValue={this.state.SelectedLanguage}
                                            onChange={(event) => this.SetLanguage(event.target.value)}
                                        >
                                            {this.state.Languages.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                    </li>

                                    <li className="separator hidden-lg"></li>
                                </ul>
                            </div>
                        </div>
                    </nav>

                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 corners-1">
                                    <div className="content-inner">
                                        <Switch>
                                            <Route exact path="/" component={defaultComponent} />
                                            <Route path="/adminmenu" component={AdminMenu} />
                                            <Route path="/settingsmenu" component={SettingsMenu} />
                                            <Route path="/reportsmenu" component={ReportsMenu} />
                                            <Route path="/login" component={Login} />
                                            <Route path="/contragentsmenu" component={ContragentsMenu} />
                                            <Route path="/changepassword" component={ChangePassword} />
                                            <Route path="/groups" component={Groups} />
                                            <Route path="/users" component={Users} />
                                            <Route path="/articlegrouping" component={ArticleGrouping} />
                                            <Route path="/warehousequery" component={WarehouseQuery} />
                                            <Route path="/Error" component={Error} />
                                            <Route path="/articles" component={Articles} />
                                            <Route path="/logout" component={Logout} />
                                            <Route path="/inout" component={InOut} />
                                            <Route path="/articlesorters" component={ArticleSorters} />
                                            <Route path="/operators" component={Operators} />
                                            <Route path="/operatorsorters" component={OperatorSorters} />
                                            <Route path="/companydata" component={CompanyData} />
                                            <Route path="/sorters" component={Sorters} />
                                            <Route path="/accounts" component={Accounts} />
                                            <Route path="/barcodes" component={Barcodes} />
                                            <Route path="/editquantity" component={EditQuantity} />
                                            <Route path="/contragents" component={Contragents} />
                                            <Route path="/manualresort" component={ManualResort} />
                                            <Route path="/sales" component={Sales} />
                                            <Route path="/salesreport" component={SalesReport} />
                                            <Route path="/deliveriesreport" component={DeliveriesReport} />
                                            <Route path="/deliveries/:on_the_road" component={Deliveries} />
                                            <Route path="/ontheway" component={OnTheWay} />
                                            <Route path="/invoices" component={Invoices} />
                                            <Route path="/corrections" component={Corrections} />
                                            <Route
                                                path="/salesreportresult/:data"
                                                component={SalesReportResult}
                                            />
                                            <Route
                                                path="/displaypackinglist/:id"
                                                component={DisplayPackingList}
                                            />
                                            <Route path="/errorsort" component={ErrorSort} />
                                            <Route path="/editdeliveries" component={EditDeliveries} />
                                            <Route path="/editsales" component={EditSales} />
                                            <Route path="/shopsmenu" component={ShopsMenu} />
                                            <Route
                                                path="/shopadministration"
                                                component={ShopAdministration}
                                            />
                                            <Route path="/n18odit" component={N18odit} />
                                            <Route path="/invoicesimport" component={InvoicesImport} />
                                            <Route path="/shopreportdetails" component={ShopReportDetails} />
                                            <Route path="/shopreportshort" component={ShopReportShort} />
                                            <Route path="/shopreportprice" component={ShopReportPrice} />
                                            <Route path="/payments" component={Payments} />
                                            <Route path="/n18tables" component={N18Tables} />
                                            <Route path="/user2sorter" component={User2Sorter} />
                                            <Route path="/barcodereport" component={BarcodeReport} />
                                            <Route path="/tare1" component={Tare1} />
                                            <Route path="/tare2" component={Tare2} />
                                            <Route path="/posterminalreport" component={PosterminalReport} />
                                            <Route path="/recapperiodreport" component={RecapForPeriodReport} />
                                            
                                        </Switch>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer className="footer">
                        <div className="container-fluid">
                            <div className="copyright">
                                © {new Date().getFullYear()}{" "}
                                <a href="http://www.ipltd-bg.com" target="_blank">
                                    Information Products Ltd
                                </a>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js